import {
  Box,
  Dialog,
  DialogContent,
  IconButton,
  Link,
  Typography,
  styled,
} from '@mui/material';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '.MuiDialog-paper': {
    borderRadius: theme.spacing(1),
    padding: theme.spacing(2),
    position: 'relative',
  },
}));

export const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  padding: theme.spacing(2),
  [theme.breakpoints.up('sm')]: {
    minWidth: '500px',
  },
}));

export const StyledCloseButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  right: theme.spacing(2),
  top: theme.spacing(2),
  color: '#666',
}));

export const StyledTitle = styled(Typography)({
  fontFamily: '"Inter", sans-serif',
  fontSize: '24px',
  fontWeight: 700,
  textAlign: 'left',
});

export const StyledDescription = styled(Typography)({
  fontFamily: '"Inter", sans-serif',
  fontSize: '14px',
  fontWeight: 400,
  textAlign: 'left',
});

export const StyledDisclaimer = styled(Typography)({
  fontFamily: '"Inter", sans-serif',
  fontSize: '12px',
  fontWeight: 400,
  textAlign: 'left',
});

export const StyledLink = styled(Link)({
  color: '#6d77c8',
  fontSize: '12px',
  '&:hover': {
    color: '#2c3050',
  },
});

export const StyledButtonContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-end',
  width: '100%',
});
